module.exports = __webpack_public_path__ + "static/media/village.b6ee748a.png";